import React, {useState, useEffect, useRef} from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { callPageRenderTracking, LoadingSection } from '../common/Helper';
import BannerImg from '../../assets/images/banner-img.svg';
import CategorySection from './CategorySection';
import ListingSection from './ListingSection';


function TopicList() {

  
    /******Category List******/
    const [isActive, setActive] = useState("false");
    const CategoryToggleClass = () => {
      setActive(!isActive);
    };

   const childRef = useRef();

   /*******get data from bucket******/
   const topicBucketState =  useSelector(state => state.TopicBucket);
   var sectionData = topicBucketState.bucket.owner_question;
   var datatrack = topicBucketState.datatrack;
    
   const [alldata, setAllData] = useState([]);

   if(sectionData && alldata <= 0){
      setAllData(sectionData);
    }

    useEffect(() => {

          callPageRenderTracking({page_title:'Topic List',page_link:window.location.href});

          /*******add class on body*****/
          document.body.classList.add('white-bg-header', 'show-search-box');
          return () => {
            document.body.classList.remove('white-bg-header', 'show-search-box');
          }

    },[]);


    var compareArrays = (a, b) => {
      var x = 0;
      a.map((innerelement) => {
        if(b.includes(innerelement)){
          x = 1;
        }
      });
    return x;
    }

     /******get Questions By categories , calling from child function of CategorySection component*******/
    const getQuestionsByCategories = (categoriesdata)=> {
      
        const res = alldata.filter(element => {
            if(compareArrays(element.categories,categoriesdata)==1){
            return element;
            }
            }
        );
            
      /*****calling child ListingSection component function to set the filtered data*******/
        childRef.current.setListingData(res);
    }

 
  return (
    <div className='fullpage-box knowledge-fullpage-box topic-content-box p-l-0 p-r-0'>

    {/* Banner start */}
    <div className='topic-banner'>
    <div className="topic-container">
      <div className='inner-container'>
        <h1 className='topic-banner-title'>All Queries</h1>
        <p>Discuss, Connect and Collaborate: Ask your queries and get answers from the experts</p>
        <div className='banner-image'><img src={BannerImg} alt="" /></div>
      </div>
    </div>
    </div>
    {/* Banner End */}


    <div className="topic-container topic-list-container">

        <div className='topic-list-box'>

        <button type='button' className='category-button' onClick={CategoryToggleClass}><span className="material-icons-outlined">category</span> Category</button>
          <div className={isActive ? "left-box" : "left-box open"}>
            <h3 className='filter-title'>Category</h3>
            {/* {categoryArray && <ul className="category-ul"><CategoriesSection datacategory={categoryArray}/></ul>} */}
            {sectionData && <CategorySection sectionData={sectionData} getQuestionsByCategories={getQuestionsByCategories}/>}
          </div>

            {/******Right listing section*******/}
            <ListingSection ref={childRef} sectionData={sectionData} datatrack={datatrack}/>

        </div>


    </div>
    </div>
  )
}

export default TopicList;